import Consulta from "../interfaces/Consulta.interface";
import Fecha from "../tools/Fecha.tool";

const getEstructura = (): Consulta => {
    const consulta: Consulta = {
        IdConsulta: 0,
        institucionClave: "Sinergia Financiera de México, S.A. de C.V., SOFOM, E.N.R.",
        sector: "Sociedades Financieras de Objeto Múltiple E.N.R.",
        consultasTrim: Fecha.getNomTrimestre(),
        numConsultas: 1,
        consultasFolio: "",
        consultasEstatusCon: 0,
        consultasFecAten: Fecha.getDateToDay(),
        estadosId: 0,
        consultasFecRecepcion: Fecha.getDateToDay(),
        mediosId: 0,
        producto: "",
        causaId: "",
        consultasCP: 0,
        consultasMpioId: 0,
        consultasLocId: 0,
        consultasColId: null,
        consultascatnivelatenId: 0,
        consultasPori: "",


        estadoDescripcion: "",
        municipioDescripcion: "",
        nivelAtencionDescripcion: "",
        productoDescripcion: "",
        causaDescripcion: ""
    };
    return consulta;
};

const validarDatosConsulta = (consulta: Consulta): { value: boolean, arrayErrors: string[] } => {
    let value: boolean = true;
    let arrayErrors: string[] = [];

    if (consulta.consultasTrim === 0) { value = false; arrayErrors.push(""); }
    if (consulta.numConsultas === 0) { value = false; arrayErrors.push("Numero de consultas en 0"); }
    if (consulta.consultasFolio.length === 0) { value = false; arrayErrors.push("El folio esta vació"); }
    if (consulta.consultasEstatusCon === 0) { value = false; arrayErrors.push("Debes de especificar el estatus"); }
    // if (consulta.consultasFecAten.length === 0) value = false;
    if (consulta.estadosId === 0) { value = false; arrayErrors.push("Debes de especificar el estado"); }
    // if (consulta.consultasFecRecepcion.length === 0) value = false;
    if (consulta.mediosId === 0) { value = false; arrayErrors.push("Debes de especificar el medio de recepción"); }
    if (consulta.producto.length === 0) { value = false; arrayErrors.push("Debes de especificar el producto"); }
    if (consulta.causaId.length === 0 || consulta.causaId === "0") { value = false; arrayErrors.push("Debes de especificar la causa"); }
    if (consulta.consultasCP === 0) { value = false; arrayErrors.push("Debes de especificar el Código Postal"); }
    if (consulta.consultasMpioId === 0) { value = false; arrayErrors.push("Debes de especificar la ciudad"); }
    if (consulta.consultasLocId === 0) { value = false; arrayErrors.push("Debes de especificar la localidad"); }
    if (consulta.consultascatnivelatenId === 0) { value = false; arrayErrors.push("Debes de especificar el nivel de atención"); }
    // if (consulta.consultasPori.length === 0) value = false;

    return { value, arrayErrors };
};

const ConsultaModel = {
    getEstructura,
    validarDatosConsulta,
};

export default ConsultaModel;